import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function CommonJS() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Common JS</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Common.js serve per utilizzare dei moduli (contenenti delle funzioni) all'interno di un progetto, nell'esempio seguente andremo a creare un nostro modulo personale (modulo.js) da utilizzare nel nostro progetto (server.js) 
                            </h5>
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Common JS VS Es Module</h2>
                            
                            {/* Inizio schema Node JS */}
                            <p className="description" style={{color: 'black'}}>
                                Node JS → usa Common.js → require → sincrono
                                <br />
                                {/* Schema Require */}
                                <p className="description text-left" style={{color: 'black'}}>
                                    Utilizzando <strong>Require</strong>:
                                    <br />- blocco il servizio (sincorno)
                                    <br />- posso inserirlo dove voglio all’interno del codice
                                    <br />- sono obbligato a importare tutto il modulo
                                </p>
                            </p>
                            {/* Fine schema Node JS */}

                            {/* Inizio schema React JS */}
                            <p className="description" style={{color: 'black'}}>
                                React JS → usa Es Module → import → asincrono
                                <br />
                                {/* Schema Import */}
                                <p className="description text-left" style={{color: 'black'}}>
                                    Utilizzando <strong>Import</strong>:
                                    <br />- non blocco il servizio (asincrono)
                                    <br />- deve essere sempre importarlo all’inizio del file
                                    <br />- con import posso fare la destrutturazione
                                </p>
                            </p>
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>

            {/* INIZIO CODICE JAVASCRIPT - modulo.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="All'interno del mio file modulo.js vado a creare le funzioni che successivamente andrò a richiamare dal server (server.js). Per esportare le funzioni utilizzo il comando 'module.exports' seguito dai nomi delle funzioni che desidero esportare"
                code={`//let pippo = 0 //Esempio di variabile locale al modulo

//Funzione SOMMA
const somma = (num1, num2) => {
    let totale = num1 + num2
    return (totale)
}

//Funzione DIFFERENZA
const differenza = (num1, num2) => {
    let totale = num1 - num2
    return (totale)
}

/*
In alterantiva posso dichiarae le funzioni con exports.{nomeDellaFunzione} al posto di const
In questo caso evito di inserire alla fine "module.exports{...}"
*/
module.exports = {somma, differenza}`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - modulo.js */}

            {/* INIZIO CODICE JAVASCRIPT - server.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Dopo aver importato il modulo per l'HTTP vado ad importare il mio modulo (creato con il file modulo.js), successivamente vado ad utilizzare la funzione somma presente nel modulo ed infine restituisco a video (res.end) il risultato dell'operazione."
                code={`let http = require("http")

//Importo il mio modulo
let mioModulo = require("./modulo")

http.createServer((req, res) => {

    //Richiamo la funzione somma presente nel mio modulo richiamato come "mioModulo", utilizzo "toString" per vedere a video il risultato (altrimenti da errore)
    res.end(mioModulo.somma(5,7).toString())

}).listen(3000)`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - server.js */}


            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/commonjs" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}
            
        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default CommonJS;
